import MenuPageItem from "./MenuPageItem";

export default function MenuPageItemDiscard({ formUtility, onClick }) {

    function handleOnClick(e) {
        if (!onClick || formUtility.fieldsDisabled)
            return;
            
        onClick();
    }

    return (
        <>
            {
                onClick
                    ? <MenuPageItem iconClassName={`fas fa-${formUtility?.hasChanges ? "ban" : "chevron-left"}`} text={formUtility?.hasChanges ? "DISCARD" : "BACK"} onClick={handleOnClick} />
                    : null
            }
        </>
    );
}